module.exports = __webpack_public_path__ + "img/anli.a3f3b69.png";